import { useAllVoices } from '@/hooks/useAllVoices';
import CaseRound from '@/images/CaseRound.svg';
import { ttsVoiceUseCaseFilter } from '@/state/presenters';
import { USE_CASE } from '@d-id/tts';
import { SelectChangeEvent } from '@mui/material/Select';
import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import { FilterChipSelect, FilterOption } from './FilterChipSelect';

const defaultOption = { value: 'all', label: 'All', chipLabel: 'Use case', icon: CaseRound, skipListIcon: true };

const useCaseOptions: FilterOption[] = [
    defaultOption,
    { value: USE_CASE.AUDIOBOOK, label: 'Audiobook' },
    { value: USE_CASE.ASMR, label: 'ASMR' },
    { value: USE_CASE.ANIMATION, label: 'Animation' },
    { value: USE_CASE.CONVERSATIONAL, label: 'Conversational' },
    { value: USE_CASE.CHILDRENS_STORIES, label: `Children's stories` },
    { value: USE_CASE.DOCUMENTARY, label: 'Documentary' },
    { value: USE_CASE.INTERACTIVE, label: 'Interactive' },
    { value: USE_CASE.MEDITATION, label: 'Meditation' },
    { value: USE_CASE.NARRATION, label: 'Narration' },
    { value: USE_CASE.NEWS, label: 'News' },
    { value: USE_CASE.VIDEO_GAMES, label: 'Video games' },
    { value: USE_CASE.NEWS_PRESENTER, label: 'News presenter' },
];
export const UseCaseChipSelect = () => {
    const { data = [] } = useAllVoices();
    const [ttsVoiceUseCaseFilterValue, setTtsVoiceUseCaseFilter] = useRecoilState(ttsVoiceUseCaseFilter);

    const handleChange = (e: SelectChangeEvent<string>) => {
        const value = (useCaseOptions.find(o => o.value === e.target.value)?.value as USE_CASE) || defaultOption.value;

        setTtsVoiceUseCaseFilter(value);
    };

    const option = useCaseOptions.find(option => option.value === ttsVoiceUseCaseFilterValue) || defaultOption;

    const availableOptions = useMemo(
        () => new Set(data.reduce((acc, voice) => (voice.useCase ? [...acc, voice.useCase] : acc), [] as string[])),
        [data.length]
    );
    const filteredUseCaseOptions = useCaseOptions.filter(
        option => availableOptions.has(option.value) || option.value === defaultOption.value
    );

    return (
        <FilterChipSelect
            data-testid="voice-use-case-filter"
            id="use-case-filter"
            value={option}
            options={filteredUseCaseOptions}
            onChange={handleChange}
            variant="outlined"
        />
    );
};
